module.exports = __webpack_public_path__ + "static/img/slogan.50bff8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/slogan.png
// module id = jXAW
// module chunks = 1 3